import { render } from "./sectionReviews.vue?vue&type=template&id=6d4e8790&scoped=true"
import script from "./sectionReviews.vue?vue&type=script&lang=js"
export * from "./sectionReviews.vue?vue&type=script&lang=js"

import "./sectionReviews.vue?vue&type=style&index=0&id=6d4e8790&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4e8790"]])

export default __exports__